import { createRef, useContext } from "react";
import "./Certificate.css";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import close from "../../../../assets/images/close.png";
import * as htmlToImage from "html-to-image";
import download from "downloadjs";
import { DOWNLOAD_CERTIFICATE } from "../../../../AppConstants/AnalyticsEventName";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { GET_CERTIFICATE_CLICK_EVENT } from "../../../../Clevertap/EventNames.ts";
import { getWebinarClickData } from "../../../../Clevertap/EventHandler.ts";

export default function Certificate({
  webinarData,
  url,
  addClickAnalytics,
  handleCertificateClose,
}) {
  const { user } = useContext(UserContext);
  const certificateBody = createRef(null);
  const certificateDownloadBtn = createRef(null);
  const { addCleverTapAnalytics } = useContext(AnalyticsContext);

  const downloadCert = async () => {
    if (certificateBody.current) {
      let cerImg = new Image();
      cerImg.onloadstart = () => {};
      cerImg.onload = async () => {
        try {
          if (certificateDownloadBtn.current) {
            certificateDownloadBtn.current.style.display = "none";
          }

          htmlToImage.toPng(certificateBody.current).then(function (dataUrl) {
            download(dataUrl, "docflix.png");
            if (certificateDownloadBtn.current) {
              certificateDownloadBtn.current.style.display = "";
            }
          });
          addCleverTapAnalytics(
            GET_CERTIFICATE_CLICK_EVENT,
            getWebinarClickData(webinarData)
          );
          addClickAnalytics(DOWNLOAD_CERTIFICATE);
        } catch (error) {
          console.error(error);
        }
      };
      cerImg.src = url || `/certificate.jpg`;
      // console.log(cerImg);
    }
  };

  return (
    <div className="modal">
      <div className="mediaModal">
        <div className="certificateContainer">
          <div ref={certificateBody} style={{ height: "100%", width: "100%" }}>
            <img
              src={url || `/certificate.jpg`}
              className="certificate"
              style={{
                // objectFit: "contain",
                height: "100%",
                width: "100%",
              }}
              alt=""
            />
            <span
              className="your_name"
              style={{ color: webinarData?.certificateTextColor || "#fff" }}
              id="your_name"
            >
              {user.displayName}
            </span>
          </div>
          <button onClick={handleCertificateClose} className="close">
            <img src={close} alt="Close" />
          </button>
          <button
            className="btn btn-secondary certDownload"
            name={"Download"}
            onClick={downloadCert}
            ref={certificateDownloadBtn}
          >
            Download
          </button>
        </div>
      </div>
    </div>
  );
}
